export const CTV_BOOTSTRAP_VISIBLE_FALLBACK_MS = 20000;

export function hasCachedNativeIdentity({
    hasUrlFingerprint,
    cachedScreenId,
    urlDeviceToken,
    deviceToken
}) {
    return Boolean(
        hasUrlFingerprint &&
        (cachedScreenId || urlDeviceToken || deviceToken)
    );
}

export function shouldSuppressFirstTimeGuideForNativeBoot({
    hasUrlFingerprint,
    screenId,
    cachedScreenId,
    urlDeviceToken,
    deviceToken
}) {
    return Boolean(
        hasUrlFingerprint &&
        (
            screenId ||
            cachedScreenId ||
            urlDeviceToken ||
            deviceToken
        )
    );
}

export function shouldShowBootstrapLoader({
    hasFingerprint,
    loader,
    connected,
    hasUrlFingerprint,
    cachedScreenId,
    urlDeviceToken,
    deviceToken
}) {
    if (!hasFingerprint) {
        return true;
    }

    if (!loader || connected) {
        return false;
    }

    if (hasCachedNativeIdentity({
        hasUrlFingerprint,
        cachedScreenId,
        urlDeviceToken,
        deviceToken
    })) {
        return true;
    }

    return Boolean(cachedScreenId);
}
